var _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 330,
    height: 72,
    viewBox: "0 0 330 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4,8) scale(0.875)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "32,12 50,22 32,32 14,22",
    fill: "#2f57c4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14,22 32,32 32,50 14,40",
    fill: "#0c36a5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50,22 32,32 32,50 50,40",
    fill: "#08267a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 17,
    x2: 41,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 17,
    x2: 23,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 27,
    x2: 23,
    y2: 45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 31,
    x2: 32,
    y2: 41
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 27,
    x2: 41,
    y2: 45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 31,
    x2: 32,
    y2: 41
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 47,
    fontFamily: "Sora, 'Segoe UI', system-ui, sans-serif",
    fontWeight: 600,
    fontSize: 37,
    letterSpacing: -0.4,
    fill: "#14171c"
  }, "Calyvern")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.88bb32f300a6d8f92cba7607ac22c72d.svg";
export { ForwardRef as ReactComponent };